// src/components/empresas/EmpresasPage/EmpresasContainer.jsx
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Chip } from '@mui/material';

import EmpresasPresentation from './EmpresasPresentation';
import { useNotification } from '../../../hooks';
import { setEmpresaActiva } from '../../../redux/empresaSlice';

/**
 * Componente contenedor para gestión de empresas (organizaciones UAU).
 * Las organizaciones son de solo lectura (se gestionan desde UAU).
 * Aquí solo se permite seleccionar la empresa activa y navegar a certificados.
 */
const EmpresasContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { empresas, empresaActiva } = useSelector(state => state.empresa);
  const { showNotification } = useNotification();

  // Seleccionar empresa activa
  const handleSelectEmpresa = useCallback((empresa) => {
    dispatch(setEmpresaActiva(empresa));
    showNotification(`Empresa "${empresa.nombre_corto || empresa.razon_social}" seleccionada como activa`, 'success');
  }, [dispatch, showNotification]);

  // Navegar a la página de certificados
  const handleNavigateToCertificados = useCallback((empresa) => {
    navigate(`/certificados/${empresa.rut}`);
  }, [navigate]);

  // Navegar a la página de configuración tributaria
  const handleNavigateToConfigTributaria = useCallback((empresa) => {
    navigate(`/config-tributaria/${empresa.rut}`);
  }, [navigate]);

  // Columnas para la tabla
  const columns = [
    {
      field: 'rut_completo',
      headerName: 'RUT',
      renderCell: (_, row) => `${row.rut}-${row.dv}`
    },
    { field: 'razon_social', headerName: 'Razón Social' },
    {
      field: 'nombre_corto',
      headerName: 'Nombre Corto',
      renderCell: (val) => val || '-'
    },
    {
      field: 'seleccionada',
      headerName: 'Empresa Activa',
      renderCell: (_, row) => empresaActiva?.id === row.id ? (
        <Chip
          label="Activa"
          color="success"
          size="small"
          variant="outlined"
        />
      ) : null
    }
  ];

  return (
    <EmpresasPresentation
      empresas={empresas}
      empresaActiva={empresaActiva}
      columns={columns}
      onSelectEmpresa={handleSelectEmpresa}
      onNavigateToCertificados={handleNavigateToCertificados}
      onNavigateToConfigTributaria={handleNavigateToConfigTributaria}
    />
  );
};

export default EmpresasContainer;
